<template>
    <div class="project">
        <template v-if="isLoaded">
            <div class="banner" v-if="data.info.banner.length > 0">
                <ProjectBanner :data="data.info.banner" :mobileData="data.info.web_banner"/>
                <div class="form_wrap">
                    <div class="container">
                        <div class="form">
                            <div class="title" v-html="textToHtml(data.info.banner_title)"></div>
                            <div class="text">{{data.info.banner_desc}}</div>
                            <div class="btn" @click="showForm = true">立即加入</div>
                            <div class="tel">租赁热线：{{data.info.banner_phone}}</div>
                            <a class="tel_mobile" :href="`tel:${data.info.banner_phone}`">立即咨询</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- form -->
            <div class="popup" :class="{active: showForm}">
                <div class="close" @click="showForm = false"></div>
                <div class="btn_close" @click="showForm = false"></div>
                <div class="in">
                    <img :src="data.info.logo" alt="" class="logo">
                    <p>我们将尽快与您联系请填写以下信息</p>
                    <input type="text" placeholder="姓名" v-model="form.name"/>
                    <input type="tel" placeholder="电话" v-model="form.phone" maxlength="11"/>
                    <p>请填写您的留言</p>
                    <textarea v-model="form.content"></textarea>
                    <div class="btn" :class="{live: formBtnLive()}" @click="upForm">立即加入</div>
                    <div class="tel">租赁热线：{{data.info.banner_phone}}</div>
                    <div class="checkbox_wrap">
                        <input type="checkbox" v-model="isChecked"/>
                        <p>查看并同意<router-link target="_blank" to="/privacy">《隐私条款》</router-link></p>
                    </div>
                </div>
            </div>
            <div class="container">
                <!-- 楼书下载 -->
                <a :href="data.info.brochure" v-if="data.info.brochure" class="pdf_file" target="_blank"></a>
                <!-- 楼层信息 -->
                <template v-if="data.is_floor_view == 1">
                    <div class="floor_info_wrap">
                        <div class="content_title">楼层信息</div>
                        <FloorInfo :data="data.floor_list"/>
                    </div>
                </template>
                <!-- 特色 -->
                <template v-if="data.is_characteristic_view == 1">
                    <div class="feature">
                        <div class="content_title">项目特色</div>
                        <FeatureImages :data="data.characteristic"/>
                    </div>
                </template>
                <div class="service">
                    <div class="cover" :style="`background-image: url(${data.service_image});`"></div>
                    <div class="text">
                        <div class="title">{{data.service_name}}</div>
                        <div class="desc">{{data.service_desc}}</div>
                        <a class="btn" :href="data.service_url">了解更多</a>
                    </div>
                </div>
                <div class="location">
                    <div class="content_title">区域交通</div>
                    <div class="map_wrap">
                        <div class="desc">
                            <div class="title">具体位置：</div>
                            <div class="text">{{data.traffic.address}}</div>
                            <div class="text" v-for="(item, index) in data.traffic.subway_line" :key="index" v-html="subway(item.name)"></div>
                            <div class="title">周边环境：</div>
                            <div class="text">{{data.traffic.environment}}</div>
                        </div>
                        <!-- <BaiduMap class="map" 
                        ak="zCiFCB9vLfOLVw3gRerBY6x9G9lvenY0"
                        :center="mapOption.center"
                        :zoom="mapOption.zoom"
                        :scroll-wheel-zoom="true"
                        :map-click="false"
                        @ready="mapReady">
                            <BmMarker :position="mapOption.center"/>
                            <template v-if="mapOption.icon.url">
                                <BmMarker :position="mapOption.center" :icon="mapOption.icon"/>
                            </template>
                        </BaiduMap> -->
                    </div>
                </div>
                <div class="peripheral_support">
                    <template v-if="data.is_matching_view == 1">
                        <div class="content_title">周边配套</div>
                        <p class="content_text">{{data.peripheral_supporting.desc}}</p>
                        <div class="images" v-if="matching_project.length> 0">
                            <div class="tabs pc">
                                <template v-for="(item, index) in matching_project">
                                    <div class="item" :key="index"
                                    :class="{active: matching_project_index == index}"
                                    @click="matching_project_index = index">{{item.name}}</div>
                                    <div class="line" :key="index + 'line'"></div>
                                </template>
                            </div>
                            <div class="tabs mobile">
                                <div class="tabs_inner" :style="`width: ${100 * matching_project.length}%; transform: translate(${-(100 / matching_project.length) * matching_project_index}%, 0)`">
                                    <template v-for="(item, index) in matching_project">
                                        <div class="item" :key="index"
                                        :class="{active: matching_project_index == index}">{{item.name}}</div>
                                    </template>
                                </div>
                                <div class="btn_prev" v-if="matching_project_index > 0" @click="imagesPrev"></div>
                                <div class="btn_next" v-if="matching_project_index < matching_project.length - 1" @click="imagesNext"></div>
                            </div>
                            <div class="desc">{{matching_project[matching_project_index].desc}}</div>
                            <ImagesBanner type="type2" :data="matching_project[matching_project_index].images" :mobileData="data.peripheral_supporting.matching_project[matching_project_index].images"/>
                        </div>
                    </template>
                    
                    <template v-if="data.is_parameter_view == 1">
                        <div class="technical_parameter">
                            <img class="pc" :src="data.technical_parameter.image" alt=""/>
                            <img class="mobile" :src="data.technical_parameter.web_image" alt=""/>
                            <div class="text">
                                <div class="title">技术参数</div>
                                <p v-for="(item, index) in data.technical_parameter.tags" :key="index">{{item}}</p>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="content_title">其他项目</div>
            </div>
            <div class="all_project">
                <img :src="data.city[cityActiveIndex].background_image" alt=""/>
                <div class="list">
                    <template v-for="(item, index) in data.city[cityActiveIndex].project">
                        <div class="item hover" 
                        v-if="item.id == data.info.id"
                        :key="index"
                        :style="`top: ${item.y}%; left: ${item.x}%; width: ${item.icon_width / 19.2}%;`">
                            <img :src="item.icon" alt="" class="icon"/>
                            <img :src="item.icon_select" alt="" class="icon_checked"/>
                        </div>
                        <router-link class="item" 
                        v-else
                        :key="index"
                        :to="`/project/${item.url}`"
                        :style="`top: ${item.y}%; left: ${item.x}%; width: ${item.icon_width / 19.2}%;`">
                            <img :src="item.icon" alt="" class="icon"/>
                            <img :src="item.icon_select" alt="" class="icon_checked"/>
                        </router-link>
                    </template>
                </div>
            </div>
            <div class="container">
                <div class="city" v-if="data.city.length > 0">
                    <div class="tabs">
                        <template v-for="(item, index) in data.city">
                            <div class="item" 
                            :key="index"
                            :class="{active: cityActiveIndex == index}"
                            @click="cityActiveIndex = index">{{item.name}}</div>
                            <div class="line" :key="'line_' + index">/</div>
                        </template>
                    </div>
                    <CityDescSwiper :data="data.city[cityActiveIndex].project" :mobileData="data.other_project"/>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
// import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
// import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import FeatureImages from '../../components/featureImages.vue';
import FloorInfo from '../../components/floorInfo.vue';
import ProjectBanner from '../../components/projectBanner.vue';
import lineBreaks from '../../utils/lineBreaks';
import config from '../../config';
import ImagesBanner from '../../components/imagesBanner2.vue';
import CityDescSwiper from '../../components/cityDescSwiper.vue';
export default {
    name: "project",
    data() {
        return {
            isLoaded: false,
            showForm: false,
            isChecked: true,
            form: {
                name: '',
                phone: '',
                content: ''
            },
            mapOption: {
                center: {lng: 0, lat: 0},
                zoom: 15,
                icon: {
                    url: '',
                    size: {width: 172, height: 65}
                }
            },
            matching_project_index: 0,
            matching_project: [],
            data: {
                characteristic: [],
                traffic: {
                    address: '',
                    subway_line: [],
                    environment: '',
                },
                info: {
                    banner: [],
                },
                peripheral_supporting: {
                    desc: '',
                    matching_project: []
                },
                technical_parameter: {
                    image: '',
                    tags: []
                },
                city: [],
            },
            cityActiveIndex: null,
        };
    },
    computed: {
        textToHtml: lineBreaks.textToHtml,
        formBtnLive(){
            return (payload)=>{
                if(this.form.name.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) this.$showToast({ text: '姓名不能为空' })
                    return false;
                }
                if(this.form.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) this.$showToast({ text: '手机号码不能为空' })
                    return false;
                }
                if(!(/^1[3-9]\d{9}$/.test(this.form.phone))){
                    if(payload) this.$showToast({ text: '手机号码格式有误' })
                    return false;
                }
                if(this.form.content.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                    if(payload) this.$showToast({ text: '留言不能为空' })
                    return false;
                }
                if(!this.isChecked){
                    if(payload) this.$showToast({ text: '请查看并同意隐私条款' })
                    return false;
                }
                return true;
            }
        },
        subway(){
            return (text)=>{
                text = text.replace(/([0-9]*)号线/, '<span class="icon" data-index="$1">$1</span>号线')
                return text;
            };
        },
    },
    components: {
        ProjectBanner,
        FloorInfo,
        FeatureImages,
        // BaiduMap,
        // BmMarker,
        ImagesBanner,
        CityDescSwiper
    },
    mounted() {
        this.getData()
    },
    watch: {
        $route(){
            this.$router.go(0)
        }
    },
    methods: {
        imagesPrev(){
            if(this.matching_project_index <= 0){
                return false;
            }
            this.matching_project_index--;
        },
        imagesNext(){
            if(this.matching_project_index >= this.matching_project.length - 1){
                return false;
            }
            this.matching_project_index++;
        },
        upForm(){
            let self = this;
            if(!this.formBtnLive(true)){
                return false;
            }
            this.$showLoading();
            this.axios.get(config.message, {
                params: {
                    id: this.data.info.id,
                    name: this.form.name,
                    phone: this.form.phone,
                    content: this.form.content,
                }
            }).then((result) => {
                self.$hideLoading();
                if(result.data.code == 100){
                    self.$showToast({ text: '提交成功' })
                    self.form = {
                        name: '',
                        phone: '',
                        content: '',
                    }
                }else{
                    self.$showToast({ text: '提交失败' })
                }
            }).catch((err) => {
                self.$hideLoading();
                self.$showToast({ text: '提交失败' })
            });
        },
        mapReady(){
            this.mapOption.center.lat = this.data.traffic.lat;
            this.mapOption.center.lng = this.data.traffic.lon;
            // this.mapOption.icon.url = this.data.traffic.map_logo;
        },
        getData(){
            let self = this;
            this.$showLoading();
            this.axios.get(config.project, {
                params: {
                    lang: localStorage.getItem('locale'),
                    // id: this.$route.query.id,
                    url: this.$route.params.path
                }
            })
            .then((result) => {
                self.$hideLoading();
                if (result.data.code == 100) {
                    self.isLoaded = true;
                    self.data = result.data.data;
                    self.mapOption.center.lat = self.data.traffic.lat;
                    self.mapOption.center.lng = self.data.traffic.lon;
                    self.mapOption.icon.url = self.data.traffic.map_logo;

                    // 周边配套图片分组
                    self.matching_project_init(self.data.peripheral_supporting.matching_project);
                    
                    // 识别当前项目所属城市
                    for (let i = 0; i < self.data.city.length; i++) {
                        const item = self.data.city[i];
                        if(item.id == self.data.city_id){
                            self.cityActiveIndex = i;
                        }
                    }
                }
            }).catch((err) => {
                self.$hideLoading();
            });
        },
        matching_project_init( payload ){
            let list = [];
            payload.forEach(v => {
                let item = { name: v.name, desc: v.desc, images: [] };
                for (let i = 0; i < v.images.length; i += 5) {
                    item.images.push(v.images.slice(i, i + 5))
                }
                list.push(item)
            });
            this.matching_project = list;
        },
    },
    destroyed() {},
};
</script>

<style scoped lang="scss">
.banner{
    position: relative;
    .form_wrap{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        .container{
            height: 100%;
            display: flex;
            flex-direction: row-reverse;
            align-items: flex-start;
            .form{
                pointer-events: auto;
                width: 3.6rem;
                margin-top: .7rem;
                padding: .3rem;
                background: rgba($color: #000000, $alpha: .5);
                border-radius: .04rem;
                color: #fff;
                line-height: 1.6;
                .title{
                    font-size: .32rem;
                    text-align: center;
                    font-weight: bold;
                    margin: .2rem 0;
                }
                .btn{
                    height: .3rem;
                    background: #ff4028;
                    border-radius: .04rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    margin: .2rem 0 .1rem;
                }
                .tel{
                    display: flex;
                    align-items: center;
                    &::before{
                        content: "";
                        display: block;
                        width: .21rem;
                        height: .21rem;
                        background: url('~@/assets/images/icon_tel.png') no-repeat 0/100%;
                        margin-right: .05rem;
                    }
                }
                .tel_mobile{
                    display: none;
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .form_wrap{
            .container{
                .form{
                    width: 100%;
                    height: 100%;
                    margin-top: 0;
                    padding: 1rem;
                    padding-bottom: 3.5rem;
                    pointer-events: none;
                    border-radius: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    font-size: .55rem;
                    line-height: 1.8;
                    .title{
                        font-size: 1rem;
                        margin: 0 0 .8rem;
                    }
                    .text{
                        letter-spacing: .05em;
                    }
                    .btn{
                        pointer-events: auto;
                        width: 9.6rem;
                        height: 1rem;
                        margin: 2rem auto 0;
                    }
                    .tel{
                        display: none;
                    }
                    .tel_mobile{
                        position: absolute;
                        top: .3rem;
                        right: 1rem;
                        display: flex;
                        align-items: center;
                        pointer-events: auto;
                        &::before{
                            content: "";
                            display: block;
                            width: .5rem;
                            height: .5rem;
                            background: url('~@/assets/images/icon_tel.png') no-repeat center/100%;
                            margin-right: .2rem;
                        }
                    }
                }
            }
        }
    }
}
.popup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: .5);
    z-index: 999;
    opacity: 0;
    visibility: hidden;
    transition: opacity .5s, visibility .5s;
    &.active{
        opacity: 1;
        visibility: visible;
    }
    .close{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
    .in{
        width: 3.6rem;
        padding: .3rem;
        border-radius: .04rem;
        background: #fff;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .logo{
            width: 1.2rem;
            margin: 0 auto .2rem;
        }
        input,
        textarea{
            width: 100%;
            display: block;
            background: none;
            box-sizing: border-box;
            border: 1px solid #f2f2f2;
            border-radius: .04rem;
            margin: .1rem 0 .15rem;
            outline: none;
        }
        input{
            height: .3rem;
            padding: 0 .1rem;
            ::placeholder{
                color: rgba($color: #000000, $alpha: .5);
            }
        }
        textarea{
            height: .5rem;
            resize: none;
            padding: .06rem .1rem;
            font-family: Arial, Helvetica, sans-serif;
        }
        .btn{
            height: .3rem;
            background: #7b7b7b;
            border-radius: .04rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin: .2rem 0 .1rem;
            color: #fff;
            &.live{
                background: #ff4028;
            }
        }
        .tel{
            display: flex;
            align-items: center;
            &::before{
                content: "";
                display: block;
                width: .21rem;
                height: .21rem;
                background: url('~@/assets/images/icon_tel2.png') no-repeat 0/100%;
                margin-right: .05rem;
            }
        }
        .checkbox_wrap{
            display: flex;
            align-items: center;
            input[type=checkbox]{
                width: .2rem;
                height: .2rem;
                border: 1px solid #000;
                border-radius: .05rem;
                margin-right: .05rem;
            }
            a{
                text-decoration: underline;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        .close{
            display: none;
        }
        .btn_close{
            width: .8rem;
            height: .8rem;
            position: absolute;
            top: 1rem;
            right: 1rem;
            z-index: 1;
            &::before,
            &::after{
                content: "";
                width: 100%;
                height: .1rem;
                display: block;
                background: #e1442b;
                border-radius: .1rem;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%) rotate(45deg);
            }
            &::after{
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }
        .in{
            width: 100%;
            height: 100%;
            padding: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: .48rem;
            .logo{
                width: 5.5rem;
                margin-bottom: 1.5rem;
            }
            p{
                margin: .25rem 0;
            }
            input,
            textarea{
                width: 9rem;
                border-width: .03rem;
                border-radius: .2rem;
                margin: .25rem 0;
                font-size: .48rem;
            }
            input{
                height: .93rem;
                padding: 0 .2rem;
            }
            textarea{
                height: 3.06rem;
                padding: .2rem;
                margin-bottom: 1.1rem;
            }
            .btn{
                width: 8.88rem;
                height: .96rem;
                border-radius: .2rem;
                margin: 0 0 .7rem;
            }
            .tel{
                &::before{
                    width: .5rem;
                    height: .5rem;
                    margin-right: .2rem;
                }
            }
            .checkbox_wrap{
                input[type=checkbox]{
                    width: .5rem;
                    height: .5rem;
                    border-radius: .1rem;
                    margin-right: .2rem;
                }
            }
        }
    }
}
.content_title{
    font-size: .26rem;
    margin-bottom: .3rem;
    @media only screen and (max-width: 1200px) {
        font-size: .72rem;
        text-align: center;
        margin: 0;
        padding: 1.2rem 0 1rem;
    }
}
.pdf_file{
    position: absolute;
    top: .7rem;
    right: -1.66rem;
    width: .96rem;
    height: .96rem;
    background: url('~@/assets/images/icon_pdf_downfile.png') no-repeat 0/100%;
    @media only screen and (max-width: 1200px) {
        display: none;
    }
}
.floor_info_wrap{
    padding: .8rem 0;
    @media only screen and (max-width: 1200px) {
        padding: 0;
        background: #e6e6e6;
    }
}
.feature{
    padding-bottom: .8rem;
    @media only screen and (max-width: 1200px) {
        padding-bottom: 1.2rem;
    }
}
.service{
    display: flex;
    padding-bottom: .8rem;
    .cover{
        width: 7.2rem;
        height: 4.4rem;
        background: no-repeat center/cover;
        margin-right: .4rem;
        border-radius: .04rem;
    }
    .text{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        line-height: 1.6;
        .title{
            margin-bottom: .3rem;
            font-size: .26rem;
            text-align: center;
        }
        .btn{
            width: .96rem;
            height: .28rem;
            border-radius: .04rem;
            background: #7b7b7b;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: .4rem;
        }
    }
    @media only screen and (max-width: 1200px) {
        display: block;
        padding-bottom: 0;
        .cover{
            margin-right: 0;
            width: 100%;
            height: 10rem;
            margin-bottom: 1.2rem;
        }
        .text{
            padding: 0 1rem;
            font-size: .48rem;
            .title{
                font-size: .72rem;
                margin-bottom: .6rem;
            }
            .btn{
                width: 3.12rem;
                height: .9rem;
                margin-top: 1rem;
            }
        }
    }
}
.location{
    padding-bottom: .8rem;
    .map_wrap{
        display: flex;
        background: #e6e6e6;
        .map{
            width: 7.5rem;
            min-height: 3.25rem;
            /deep/.BMap_Marker{
                pointer-events: none;
                div{
                    transform: translate3d(0,100%,0);
                }
            }
        }
        .desc{
            flex: 1;
            padding: .2rem .35rem;
            line-height: 1.8;
            .title{
                font-weight: bold;
                margin-top: .1rem;
                &:first-child{
                    margin-top: 0;
                }
            }
            .text{
                /deep/.icon{
                    width: .2rem;
                    height: .2rem;
                    display: inline-block;
                    border-radius: 50%;
                    line-height: .2rem;
                    text-align: center;
                    margin-right: .05rem;
                    font-size: .14rem;
                    color: #fff;
                    &[data-index="1"]{
                        background: rgb(234,27,57);
                    }
                    &[data-index="2"]{
                        background: rgb(139,196,63);
                    }
                    &[data-index="3"]{
                        background: rgb(251,210,8);
                    }
                    &[data-index="4"]{
                        background: rgb(81,45,141);
                    }
                    &[data-index="5"]{
                        background: rgb(144,86,163);
                    }
                    &[data-index="6"]{
                        background: rgb(214,24,112);
                    }
                    &[data-index="7"]{
                        background: rgb(244,113,33);
                    }
                    &[data-index="8"]{
                        background: rgb(0,158,219);
                    }
                    &[data-index="9"]{
                        background: rgb(121,201,238);
                    }
                    &[data-index="10"]{
                        background: rgb(189,168,211);
                    }
                    &[data-index="11"]{
                        background: rgb(127,33,49);
                    }
                    &[data-index="12"]{
                        background: rgb(1,124,103);
                    }
                    &[data-index="13"]{
                        background: rgb(232,149,193);
                    }
                    &[data-index="14"]{
                        background: rgb(94,92,41);
                    }
                    &[data-index="15"]{
                        background: rgb(187,167,134);
                    }
                    &[data-index="16"]{
                        background: rgb(142,209,192);
                    }
                    &[data-index="17"]{
                        background: rgb(184,121,116);
                    }
                    &[data-index="18"]{
                        background: rgb(186,160,81);
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        padding-bottom: 0;
        .map_wrap{
            flex-direction: column-reverse;
            .map{
                width: 100%;
                height: 8.7rem;
            }
            .desc{
                padding: 1rem;
                font-size: .48rem;
                .title{
                    font-size: .56rem;
                    margin-top: .6rem;
                }
                .text{
                    /deep/.icon{
                        width: .72rem;
                        height: .72rem;
                        font-size: .48rem;
                        line-height: .72rem;
                    }
                }
            }
        }
    }
}
.peripheral_support{
    padding-bottom: .8rem;
    .images{
        padding-bottom: .8rem;
        .tabs{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: .26rem;
            color: rgba($color: #000000, $alpha: .5);
            line-height: 1;
            margin: .5rem 0;
            &.mobile{
                display: none;
            }
            .item{
                cursor: pointer;
                &:hover,
                &.active{
                    color: #ff4836;
                }
            }
            .line{
                width: .02rem;
                height: .3rem;
                background: rgba($color: #ff4836, $alpha: .5);
                margin: 0 .2rem;
                &:last-child{
                    display: none;
                }
            }
        }
        .desc{
            text-align: center;
            margin-bottom: .5rem;
        }
    }
    .technical_parameter{
        position: relative;
        .mobile{
            display: none;
        }
        .text{
            position: absolute;
            top: 0;
            right: 0;
            min-width: 4.6rem;
            background: rgba($color: #000000, $alpha: .5);
            color: #fff;
            padding: .6rem .3rem .8rem .7rem;
            line-height: 2;
            white-space: nowrap;
            .title{
                font-size: .26rem;
                margin-bottom: .1rem;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        padding-bottom: 0;
        .content_text{
            padding: 0 1rem;
            margin-bottom: 1rem;
        }
        .images{
            padding-bottom: 1.2rem;
            .tabs{
                display: block;
                margin: 0;
                font-size: .6rem;
                position: relative;
                overflow: hidden;
                margin-bottom: .4rem;
                &.pc{
                    display: none;
                }
                &.mobile{
                    display: block;
                }
                .tabs_inner{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: transform .5s;
                }
                .item{
                    width: 100%;
                    height: 1rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &.active{
                        font-weight: bold;
                    }
                }
                .line{
                    display: none;
                }
                .btn_prev,
                .btn_next{
                    position: absolute;
                    width: .48rem;
                    height: .61rem;
                    top: 50%;
                    transform: translate(0, -50%);
                    background: no-repeat center/100%;
                }
                .btn_prev{
                    left: 2.8rem;
                    background-image: url('~@/assets/images/icon_arrow_prev.svg');
                }
                .btn_next{
                    right: 2.8rem;
                    background-image: url('~@/assets/images/icon_arrow_next.svg');
                }
            }
        }
        .technical_parameter{
            .pc{
                display: none;
            }
            .mobile{
                display: block;
            }
            .text{
                padding: .6rem 1rem;
                position: relative;
                background: #e6e6e6;
                text-align: center;
                color: #000;
                .title{
                    font-size: .72rem;
                }
            }
        }
    }
}
.city{
    margin-bottom: .5rem;
    .tabs{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .26rem;
        margin-bottom: .5rem;
        line-height: 1;
        .item{
            cursor: pointer;
            &.active{
                color: #ff4836;
                font-weight: bold;
            }
        }
        .line{
            margin: 0 .1rem;
            &:last-child{
                display: none;
            }
        }
    }
    @media only screen and (max-width: 1200px) {
        margin-bottom: 1.2rem;
        .tabs{
            display: none;
        }
    }
}
.all_project{
    @media only screen and (max-width: 1200px) {
        display: none;
    }
    img{
        width: 100%;
    }
    margin: 0 auto .5rem;
    position: relative;
    .list{
        .item{
            position: absolute;
            &.hover,
            &:hover{
                .icon{
                    display: none;
                }
                .icon_checked{
                    display: block;
                }
            }
            .icon_checked{
                display: none;
            }
        }
    }
}
</style>